import React, { useState } from "react";

import { Box, Button } from "@mui/material";

import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { ClipLoader } from "react-spinners";

import {
    createGoogleEnhanceMapping,
    createGoogleWebMapping,
} from "helpers/destinations/createDestination";

import GoogleOfflinePixels from "components/GoogleOfflinePixels";
import LinkedinSignalMappingEdit from "components/organisms/CRMs/LinkedinSignalDestination/LinkedinSignalMappingEdit";
import MicrosoftBingMappingEdit from "components/organisms/CRMs/MicrosoftBingDestination/MicrosoftBingMappingEdit";
import GoogleAdsConversionMappingEdit from "components/organisms/Destinations/GoogleAdsConversion/GoogleAdsConversionMappingEdit";
import OpenAiAdsMappingEdit from "components/organisms/Destinations/OpenAiAds/OpenAiAdsMappingEdit";
import SignalSightTaskDestinationMapping from "components/organisms/Destinations/SignalSightTaskDestinationMapping";
import SwalAlertComp from "components/SwalAlert";

import { getSingleTrackerRedux } from "../../../../../../../redux/slices/trackers/trackers.asyncActions";
import { EditMappingTabProps } from "../../../DestinationModal.types";

const EditMappingTab: React.FC<EditMappingTabProps> = ({
    destination,
    tracker,
    language,
    onRefresh,
    onClose,
}) => {
    const params = useParams<{ id: string }>();
    const dispatch = useDispatch();
    const destinationCode = destination?.destination_type?.code;
    const destinationId = destination?.id;

    const [enhanceMapping, setEnhanceMapping] = useState<any>({});
    const [isLoadingGgadsEditMapping, setIsLoadingGgadsEditMapping] =
        useState(false);

    const ggadsEditMapingSave = async () => {
        let isValid = true;
        setIsLoadingGgadsEditMapping(true);

        if (isValid) {
            const action =
                destinationCode === "ggads_web"
                    ? createGoogleWebMapping
                    : createGoogleEnhanceMapping;

            const response = await action(destinationId, enhanceMapping);

            if (response.status) {
                SwalAlertComp({
                    title: language?.delete_swal_modal?.success ?? "Success",
                    message: response.message,
                    icon: "success",
                    timer: 3000,
                });
                onClose?.();
                if (params.id) {
                    dispatch(getSingleTrackerRedux(params.id) as any);
                }
            } else {
                SwalAlertComp({
                    title: language?.delete_swal_modal?.failed ?? "Failed",
                    message: response.message,
                    icon: "error",
                });
            }
            setIsLoadingGgadsEditMapping(false);
        }
    };

    return (
        <div>
            <p>
                Allows for updating the configuration between the source and
                destination, facilitating changes and refinements in the data
                mapping process.
            </p>

            {destinationCode === "sstask" && (
                <SignalSightTaskDestinationMapping
                    destinationId={destinationId}
                    setButtonDisabledStatus={() => {}}
                    onFieldsChange={() => {}}
                    onSaveSuccess={() => {
                        onClose?.();
                        if (params.id) {
                            dispatch(getSingleTrackerRedux(params.id) as any);
                        }
                    }}
                    isModal
                />
            )}

            {destinationCode === "licapi" && (
                <LinkedinSignalMappingEdit
                    destinationId={destinationId}
                    onSaveSuccess={() => {
                        onClose?.();
                        if (params.id) {
                            dispatch(getSingleTrackerRedux(params.id) as any);
                        }
                    }}
                    isModal
                />
            )}

            {destinationCode === "msoffline" && (
                <MicrosoftBingMappingEdit
                    destinationId={destinationId}
                    onSaveSuccess={() => {
                        onClose?.();
                        if (params.id) {
                            dispatch(getSingleTrackerRedux(params.id) as any);
                        }
                    }}
                    isModal
                />
            )}

            {destinationCode === "oaicapi" && (
                <OpenAiAdsMappingEdit
                    destinationId={destinationId}
                    onSaveSuccess={() => {
                        onClose?.();
                        if (params.id) {
                            dispatch(getSingleTrackerRedux(params.id) as any);
                        }
                    }}
                />
            )}

            {(destinationCode === "ggawc" ||
                destinationCode === "ggaoc" ||
                destinationCode === "ggalc" ||
                destinationCode === "ggass") && (
                <GoogleAdsConversionMappingEdit
                    destinationId={destinationId}
                    type={destinationCode}
                    onSaveSuccess={() => {
                        onClose?.();
                        if (params.id) {
                            dispatch(getSingleTrackerRedux(params.id) as any);
                        }
                    }}
                    isModal
                />
            )}

            {(destinationCode === "ggads" ||
                destinationCode === "ggads_web") && (
                <div className="edit-mapping-area">
                    <Form>
                        <Modal.Body>
                            <Box>
                                <GoogleOfflinePixels
                                    setEnhanceMapping={setEnhanceMapping}
                                    editMappingStatu={true}
                                    ggadsDestinationId={destinationId}
                                    setButtonDisabledStatus={() => {}}
                                    destinationType={destinationCode}
                                    googleEnhanceData={enhanceMapping}
                                />
                            </Box>
                        </Modal.Body>
                    </Form>
                    <Modal.Footer>
                        <div className="position-relative overflow-hidden">
                            {isLoadingGgadsEditMapping && (
                                <div className="circle-loader">
                                    <ClipLoader color={"#000"} size={17} />
                                </div>
                            )}
                            <Button
                                color="primary"
                                variant="contained"
                                onClick={ggadsEditMapingSave}
                            >
                                Save
                            </Button>
                        </div>
                    </Modal.Footer>
                </div>
            )}
        </div>
    );
};

export default EditMappingTab;
